import script from "./TheResult.vue?vue&type=script&setup=true&lang=js"
export * from "./TheResult.vue?vue&type=script&setup=true&lang=js"

import "./TheResult.vue?vue&type=style&index=0&id=0d4f8568&scoped=true&lang=css"

import exportComponent from "F:\\.openserver\\OpenServer\\domains\\geo_exams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d4f8568"]])

export default __exports__